/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-22 11:37:17
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-05 14:51:28
 */

const cooperativeShopMenus = [
	{
		path: '/cooperativeShop',
		component: null,
		name: '合作店铺',
		id: 2,
		parentId: 0,
		keepAlive: false,
		showBread: false,
		visible: true,
		useTemplate: false,
		redirect: '/cooperativeShop/list',
		children: [
			{
				path: 'list',
				component: 'cooperativeShop/shopList',
				name: '店铺列表',
				parentId: 2,
				id: 10,
				keepAlive: false,
				showBread: true,
				visible: true,
				useTemplate: false,
			},
			{
				path: 'collaborateRules',
				component: null,
				name: '协作规则',
				parentId: 2,
				id: 10,
				keepAlive: false,
				showBread: true,
				visible: true,
				useTemplate: true,
				redirect: '/cooperativeShop/collaborateRules/viewRules',
				children: [
					{
						path: 'viewRules',
						name: '协作规则',
						parentId: 10,
						component: 'cooperativeShop/collaborateRules/viewRules',
						keepAlive: false,
						showBread: false,
						visible: true,
						useTemplate: false,
					},
					{
						path: 'editRules',
						component: 'cooperativeShop/collaborateRules/editRules',
						name: '修改规则',
						parentId: 10,
						keepAlive: false,
						showBread: true,
						visible: true,
						useTemplate: true,
					},
				],
			},
		],
	},
];
export default cooperativeShopMenus;
